import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import { useContent } from '../../../redux/reducer/content';
import { safeHTML } from '../../../utils/safeHTML';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { useTranslation } from '../../../translations';

const WelcomeBackModal = React.forwardRef(function WelcomeBackModal({ title, text, buttonText, callbacks }, ref) {
  const { state } = useContent();
  const { id, closeModal } = useModal();
  const { t } = useTranslation();

  const close = () => {
    callbacks?.onClose?.();
    closeModal({ id });
  };

  return (
    <CustomModal>
      <div className={classNames(`welcome-back-modal welcome-back-modal_${state}`)} ref={ref}>
        <div className={classNames('welcome-back-modal__content')}>
          <h2 className={classNames('welcome-back-modal__title')}>{safeHTML(t(title))}</h2>
          <p className={classNames('welcome-back-modal__text')}>{safeHTML(t(text))}</p>
          <CustomButton className={classNames('welcome-back-modal__button')} text={buttonText} onClick={close} />
        </div>
      </div>
    </CustomModal>
  );
});

export default WelcomeBackModal;
WelcomeBackModal.propTypes = {};
